import { render, staticRenderFns } from "./mainTain.vue?vue&type=template&id=20b71451"
import script from "./mainTain.vue?vue&type=script&lang=js"
export * from "./mainTain.vue?vue&type=script&lang=js"
import style0 from "./mainTain.vue?vue&type=style&index=0&id=20b71451&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports